import { FC, Suspense } from 'react';
import { TrackerScript } from './tracker-script';
import { TrackerQueue } from './tracker-queue';
import { TrackClickAttribution } from './track-click-attribution';
import { TrackFormAttribution } from './track-form-attribution';
import { ClientMessageSender } from './client-message-sender';
import { ConsentDialogObserver } from './consent-dialog-observer';

export type TrackerProps = {
  // App-Based possibility to disable tracking
  disableTracking?: boolean;
};

export const Tracker: FC<TrackerProps> = props => {
  return (
    <Suspense>
      <TrackerScript disableTracking={props.disableTracking} />
      <TrackClickAttribution />
      <TrackFormAttribution />
      <TrackerQueue />
      <ClientMessageSender />
      <ConsentDialogObserver />
    </Suspense>
  );
};
